import { t } from '@transifex/native';
import type { components } from '~/api/openapi';

export type XpLevel = components['schemas']['GamificationStatsDto']['currentTier'];
export type XpLevelThreshold = components['schemas']['TierThresholdDto'];

type XpLevelConfig = {
  borderColor: string;
  badgeSrc: string;
};

const LEVEL_CONFIG = {
  OBSERVER: {
    borderColor: '#008D7E',
    badgeSrc: '/assets/gamification/level-observer.svg',
  },
  SCOUT: {
    borderColor: '#DE8B92',
    badgeSrc: '/assets/gamification/level-scout.svg',
  },
  RANGER: {
    borderColor: '#F3F768',
    badgeSrc: '/assets/gamification/level-ranger.svg',
  },
  NAVIGATOR: {
    borderColor: '#6F92F5',
    badgeSrc: '/assets/gamification/level-navigator.svg',
  },
  VOYAGER: {
    borderColor: '#E66D04',
    badgeSrc: '/assets/gamification/level-voyager.svg',
  },
} as const satisfies Record<XpLevel, XpLevelConfig>;

export function getXpLevelConfig(level: XpLevel): XpLevelConfig {
  return LEVEL_CONFIG[level];
}

export function getXpLevelName(level: XpLevel | undefined): string | null {
  switch (level) {
    case 'OBSERVER':
      return t('Observer');
    case 'SCOUT':
      return t('Scout');
    case 'RANGER':
      return t('Ranger');
    case 'NAVIGATOR':
      return t('Navigator');
    case 'VOYAGER':
      return t('Voyager');
    default:
      return null;
  }
}
